import type { StateCreator } from 'zustand';

export interface AlertsTourSliceState {
  progressBar: boolean;
  progressBarTitle: string;
  onboardingStepName: string;
  progressBarTourStepsTotal: number;
  alertsInitialTour: boolean;
  alertsTourModal: boolean;
  alertsTour: boolean;
  setAlertsInitialTour: (value: boolean) => void;
  setAlertsTourModal: (value: boolean) => void;
  setAlertsTour: (value: boolean) => void;
  setAlertsTourStart: () => void;
  setAlertsTourFinish: () => void;
}

type StateCreatorAlertsTour = StateCreator<AlertsTourSliceState>;

const initialStates = {
  progressBar: false,
  progressBarTitle: 'Configure seus alertas no painel',
  onboardingStepName: '',
  progressBarTourStepsTotal: 0,
  alertsInitialTour: false,
  alertsTour: false,
  alertsTourModal: false,
};

const createAlertsTourSlice: StateCreatorAlertsTour = (set) => ({
  ...initialStates,
  setAlertsInitialTour: (alertsInitialTour: boolean) => set({ alertsInitialTour }),
  setAlertsTourModal: (alertsTourModal: boolean) => set({ alertsTourModal }),
  setAlertsTour: (alertsTour: boolean) => set({ alertsTour }),
  setAlertsTourStart: () =>
    set({
      ...initialStates,
      progressBar: true,
      onboardingStepName: 'Alert',
      progressBarTourStepsTotal: 5,
      alertsInitialTour: true,
    }),
  setAlertsTourFinish: () =>
    set({
      ...initialStates,
      progressBar: true,
    }),
});

export default createAlertsTourSlice;
